import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Crosshair, ChevronRight, AlertTriangle } from "lucide-react";

export const IcpHealthCard = ({ userId, instanceId, onOpenTargeting }) => {
  const [health, setHealth] = useState(null);

  useEffect(() => {
    if (!userId || userId === "new") return;
    axios.get(`${API}/onboarding/icp-health/${userId}`, { params: instanceId ? { instanceId } : {} })
      .then((r) => setHealth(r.data)).catch(() => setHealth(null));
  }, [userId, instanceId]);

  if (!health?.hasSpec) return null;
  const color = health.score >= 8 ? "text-ism-teal" : health.score >= 5 ? "text-amber-400" : "text-red-400";
  const bar = health.score >= 8 ? "bg-ism-teal" : health.score >= 5 ? "bg-amber-400" : "bg-red-400";
  const next = health.missing[0];

  return (
    <button onClick={onOpenTargeting} className="w-full text-left glass-card p-4 hover:border-ism-teal/30 transition-colors group" data-testid="icp-health-card">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="p-2 rounded-lg bg-ism-teal/10 border border-ism-teal/20"><Crosshair className="h-4 w-4 text-ism-teal" /></div>
          <div className="min-w-0">
            <p className="text-sm text-white">ICP health <span className={`${color} font-medium`} data-testid="icp-health-score">{health.score}/10</span></p>
            <p className="text-xs text-gray-500 truncate">
              {health.stale ? <span className="text-amber-400 inline-flex items-center gap-1"><AlertTriangle className="h-3 w-3" /> New intelligence — review targeting</span>
                : next ? `Improve: ${next.hint}` : "Fully specified — the agent is learning from your feedback"}
            </p>
          </div>
        </div>
        <ChevronRight className="h-4 w-4 text-gray-600 group-hover:text-ism-teal flex-shrink-0" />
      </div>
      <div className="mt-3 h-1 bg-white/10 rounded-full overflow-hidden"><div className={`h-full ${bar} transition-all`} style={{ width: `${health.score * 10}%` }} /></div>
    </button>
  );
};
